import React from "react";
import "./feature.scss";
import featureImage from "./feature.svg";
import { useState, useEffect } from "react";
import { db } from "../../firebase_setup/firebase";
import { doc, getDoc } from "firebase/firestore";
const Feature = () => {

  async function fetch() {
    const docSnap = await getDoc(docRef);
    if (docSnap) {
      setFeature(docSnap.data());
    }


    console.log(featureHeading["body"]);
  }

  const [featureHeading, setFeature] = useState({});
  const docRef = doc(db, "feature", "HCf5ew8KMNVOMT85AHff");
  useEffect(() => {
    fetch();
  });
  return (
    <div className="feature" id="pricing">
      <div className="feature-heading">
        <h2>
          {featureHeading["heading"] ? featureHeading["heading"].substring(0, 10) : ""}<span>{featureHeading["heading"] ? featureHeading["heading"].substring(10, 28) : ""}</span>
        </h2>
        <h2>{featureHeading["heading"] ? featureHeading["heading"].substring(28, 59) : ""}</h2>
        <p>{featureHeading["body"] ? featureHeading["body"].substring(0, 35) : ""}</p>
      </div>
      <div className="feature-image-container">
        <div className="image-container">
          <img src={featureImage} alt="" />
        </div>
        <div className="feature-plan">
          <div className="feature-plans-points">
            <div className="heading">
              <div className="indexing">
                <p>1</p>
              </div>
              <h4>14 Days Free Access</h4>
            </div>
            <div className="para">
              <p>
                {featureHeading["cards"] ? featureHeading["cards"]["14 Days Free Access"] : ""}
              </p>
            </div>
          </div>
          <div className="feature-plans-points">
            <div className="heading">
              <div className="indexing">
                <p>2</p>
              </div>
              <h4>Upgrade Plan</h4>
            </div>
            <div className="para">
              <p>
                {featureHeading["cards"] ? featureHeading["cards"]["Upgrade Plan"] : ""}
              </p>
            </div>
          </div>
          <div className="feature-plans-points">
            <div className="heading">
              <div className="indexing">
                <p>3</p>
              </div>
              <h4>API Analytics</h4>
            </div>
            <div className="para">
              <p>
                {featureHeading["cards"] ? featureHeading["cards"]["API Analytics"] : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
